

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API_URL = `${BACKEND_URL}/api`;


// Log configuration on load
